import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogTitle } from '@angular/material/dialog';
import { CustomerBiller } from '../../models/model';
import { MatButton } from '@angular/material/button';

@Component({
  standalone: true,
  selector: 'app-refresh-confirmation-dialog',
  styleUrls: ['./refresh-confirmation-dialog.component.scss'],
  templateUrl: './refresh-confirmation-dialog.component.html',
  imports: [
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatDialogTitle,
  ],
})
export class RefreshConfirmationDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public customerBiller: CustomerBiller) {}
}
